import { IconHome } from '@/components/Icon/HeaderIcon'
import ImageOptimize from '@/components/ImageOptimize'
import { PageType } from '@/constants'
import { useNotification, useStore } from '@/containers'
import { useRouterBack } from '@/hooks/useRouterBack'
import { IconBack, IconBackWhite, SearchIconBlue } from '@/styles/Icon'
import Link from 'next/link'
import { useMemo } from 'react'
interface HeaderType {
  layout: string
  page: string
  theme?: string
  dataHeader: string | undefined
  btnHome?: boolean
}
const Header = ({
  layout,
  dataHeader,
  btnHome = true,
  page,
  theme,
}: HeaderType) => {
  const { systemConfig } = useNotification()
  const handleGoBack = useRouterBack()
  const { regions, saleRegion, setIsOpenPopupLocation, province } = useStore()
  const renderInput = useMemo(() => {
    const matchedProvince = regions?.find(e => e.code === province)
    const fallbackRegion = regions?.find(e => e.code === saleRegion)
    const displayName =
      matchedProvince?.name || fallbackRegion?.name || 'Chọn khu vực'

    return (
      <div
        onClick={() => setIsOpenPopupLocation(true)}
        className='flex h-[48px] w-full cursor-pointer items-center justify-center gap-[6px]'
      >
        <span className='inline-block text-center text-xs leading-tight text-white'>
          {displayName}{' '}
          <svg
            width='8'
            height='5'
            viewBox='0 0 8 5'
            className='inline-block'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M4 5L7.4641 0.714286H0.535898L4 5Z' fill='white' />
          </svg>
        </span>
      </div>
    )
  }, [regions, saleRegion, province])
  const headerDefault = useMemo(() => {
    return (
      <div className='flex h-[60px] w-full items-center justify-between bg-primary-base px-1'>
        <div className='max-w-[40px] flex-[40px]'>
          <button
            className='flex h-10 w-10 items-center justify-center outline-none'
            onClick={() => handleGoBack(true)}
          >
            {theme == 'dark' ? <IconBackWhite /> : <IconBack />}
          </button>
        </div>

        <div className='w-full flex-1 px-1'>
          <h1 className='line-clamp-1 overflow-hidden text-ellipsis break-all text-base font-bold text-white'>
            {dataHeader}
          </h1>
        </div>
        {btnHome ? (
          <div className='max-w-[40px] flex-[40px]'>
            <Link
              className='flex h-10 w-10 items-center justify-center outline-none'
              href={'/'}
            >
              <IconHome />
            </Link>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }, [dataHeader])
  return (
    <>
      {layout == PageType.HOMEPAGE && (
        <header
          className={`sticky left-[50%] top-0 z-[999] flex h-[63px] w-full max-w-[440px] items-center justify-between bg-primary-base pt-2`}
        >
          <div
            className={`flex w-full items-center justify-between gap-2 px-2`}
          >
            <div className='relative mr-2 max-w-[96px] flex-[0_0_96px] text-[0px] md:max-w-[109px] md:flex-[0_0_109px]'>
              {page && page == 'homepage' ? (
                <h1 className='block'>
                  <ImageOptimize
                    loading='eager'
                    priority
                    className='h-auto w-full'
                    alt={systemConfig?.websiteBrandName || 'Logo'}
                    src={systemConfig?.companyLogoHeaderMobile || ''}
                    width={109}
                    height={28}
                    quality={100}
                  />
                </h1>
              ) : (
                <div className='block'>
                  <ImageOptimize
                    loading='eager'
                    priority
                    className='h-auto w-full'
                    alt={systemConfig?.websiteBrandName || 'Logo'}
                    src={systemConfig?.companyLogoHeaderMobile || ''}
                    width={109}
                    height={28}
                    quality={100}
                  />
                </div>
              )}
            </div>
            <Link
              href={'/search'}
              className='flex h-[40px] w-full flex-1 items-center justify-between gap-2 overflow-hidden rounded-lg bg-white py-2 pl-2 pr-2'
            >
              <SearchIconBlue />
              <span className='flex-1 text-[13px] text-gray-900 md:text-sm '>
                Bạn cần tìm gì hôm nay?
              </span>
            </Link>
            <div className='relative max-w-[64px] flex-[64px]'>
              {renderInput}
            </div>
          </div>
        </header>
      )}

      {layout == '' && headerDefault}
    </>
  )
}
export { Header }
